function checkAndApplyClass() {
  const interval = setInterval(() => {
    const button = document.querySelector('.product-form__submit.button.button--full-width.button--secondary');
    if (button) {
      button.classList.add('opusNoAtc');
      clearInterval(interval); 
    }
  }, 100);
}

window.addEventListener('DOMContentLoaded', checkAndApplyClass);

function handleCartEvents(event) {
    const addons3 = document.querySelector('.opus-warp-addons > div:nth-child(3)');
    const totalPrice = event.detail.items_subtotal_price;

    const converted = window.OpusConvertMoney(9900);
    const convertedNumber = parseInt(converted.replace(/[^\d]/g, ''), 10);

    console.log('So sánh:', totalPrice, 'vs', addons3, convertedNumber);

    if (totalPrice > convertedNumber) {
        addons3.style.display = 'none';
    } else {
        addons3.style.display = 'flex';
    }
}

window.addEventListener('OpusCartChange', handleCartEvents);
